import { FunctionComponent } from 'react';
import { TimePicker as MuiTimePicker } from '@mui/x-date-pickers/TimePicker';
import { TextField, TextFieldProps } from '@mui/material';
import { format, isValid, parse } from 'date-fns';

type TimePickerProps = {
    label: string;
    // ISO local time ("HH:mm" or "HH:mm:ss"), null = empty
    value: string | null;
    // Emits "HH:mm:ss", or null when the field is cleared
    onChange: (time: string | null) => void;
    disabled?: boolean;
    textFieldProps?: TextFieldProps;
};

const parseIsoTime = (value: string | null): Date | null => {
    if (!value) {
        return null;
    }
    const parsed = parse(value.substring(0, 5), 'HH:mm', new Date());
    return isValid(parsed) ? parsed : null;
};

export const TimePicker: FunctionComponent<TimePickerProps> = ({
    label,
    value,
    onChange,
    disabled = false,
    textFieldProps = {},
}) => {
    return (
        <MuiTimePicker<Date>
            label={label}
            ampm={false}
            inputFormat='HH:mm'
            value={parseIsoTime(value)}
            onChange={(date) => {
                if (date === null) {
                    onChange(null);
                    return;
                }
                // Ignore incomplete input; the last valid value is kept
                if (isValid(date)) {
                    onChange(format(date, 'HH:mm:ss'));
                }
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    inputProps={{
                        ...params.inputProps,
                        placeholder: 'hh:mm',
                    }}
                    {...textFieldProps}
                    fullWidth
                />
            )}
            disabled={disabled}
        />
    );
};
